import React from 'react'

export default class NewUserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: null,
      lastName: null,
      companyName: null,
      email: null,
      password: null
    };
  };

  updateValue(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleCompanyNameBlur(e) {
    if(e.target.value.length > 0 && e.target.value != this.state.companyName) {
      Promise.all([this.updateValue(e)]).then( () => {
        this.submitCompanyName()
      });
    }
  }

  submitCompanyName() {
    let that = this;
    let xhr = new XMLHttpRequest();
    let url = `/api/v3/company_url?name=${this.state.companyName}`
    xhr.open('GET', url, true);
    xhr.setRequestHeader("X-CSRF-TOKEN", this.props.authenticityToken);
    xhr.setRequestHeader("Content-type", 'application/json');
    xhr.onreadystatechange = function () {
      if(this.readyState == 4 && this.status == 200) {
        that.props.updateOnboarding({company: JSON.parse(this.response)});
      }
    }
    xhr.send();
  }

  createNewUser(e) {
    e.preventDefault();
    let that = this;
    let params =  { uninvited_user: true,
                    user: {
                      first_name: this.state.firstName,
                      last_name: this.state.lastName,
                      email: this.state.email,
                      password: this.state.password
                    }
                  }
    let xhr = new XMLHttpRequest();
    xhr.open('POST', '/signup', true);
    xhr.setRequestHeader("X-CSRF-TOKEN", this.props.authenticityToken);
    xhr.setRequestHeader("Content-type", 'application/json');
    xhr.setRequestHeader("X-Requested-With", 'XMLHttpRequest');
    xhr.onreadystatechange = function () {
      if(this.readyState == 4 && this.status == 200) {
        let response = JSON.parse(this.response);
        let currentUser = { email: response.email, first_name: response.first_name, last_name: response.last_name, user_key: response.user_key }
        that.props.updateOnboarding({
          currentUser: currentUser,
          authenticityToken: response.form_authenticity_token,
          stage: that.props.stage + 1
        });
      } else if(this.readyState == 4 && this.status == 422) {
        let response = JSON.parse(this.response);
        let message = response.errors.join('\n');
        swal({title: "Error!", text: message, type: "error" });
      } else if(this.readyState == 4) {
        swal({title: "Error!", text: 'Please ensure your information is correct and you do not already have an account associated with this email.', type: "error" });
      }
    }
    xhr.send(JSON.stringify(params));
  }

  signoutCurrentUser(e) {
    const that = this;
    let xhr = new XMLHttpRequest();
    let url = `/signout`
    xhr.open('GET', url, true);
    xhr.setRequestHeader("Content-type", 'application/json');
    xhr.setRequestHeader("X-Requested-With", 'XMLHttpRequest');
    xhr.onreadystatechange = function (response) {
      if(this.readyState == 4 && this.status == 200) {
        let response = JSON.parse(this.response);
        that.props.updateOnboarding({ currentUser: null, authenticityToken: response['csrf-token'] });
      }
    }
    xhr.send();
  }
  render () {
    if(this.props.currentUser) {
      return (
        <div className='content content--step1'>
          <h2>Continue as</h2>
          <h2>{this.props.currentUser.email}</h2>
          <button className='content--step1__btn dark' onClick={() => this.props.updateOnboarding({stage: this.props.stage + 1})}>
            Continue
          </button>
          <div className='content__bot-div'>
            <h5>Not {this.props.currentUser.email}?</h5>
            <a onClick={(e) => this.signoutCurrentUser(e)} className='link'><h5>Create an Account</h5></a>
          </div>
        </div>
      )
    } else {
      return (
        <div className='content content--step1'>
          <form>
            <div className='row name-row'>
              <div className='row-half'>
                <label htmlFor='user_first_name'>First Name</label>
                <input type='text' name='firstName' onChange={(e) => this.updateValue(e)} />
              </div>
              <div className='row-half'>
                <label htmlFor='user_last_name'>Last Name</label>
                <input type='text' name='lastName' onChange={(e) => this.updateValue(e)} />
              </div>
            </div>

            <div className='row row-full'>
              <label htmlFor='company_name'>Company Name (Recommended)</label>
              <input type='text' name='companyName' onBlur={(e) => this.handleCompanyNameBlur(e)} />
            </div>

            <div className='row row-full'>
              <label htmlFor='user_email'>Email</label>
              <input type='text' name='email' onChange={(e) => this.updateValue(e)} />
            </div>

            <div className='row row-full'>
              <label htmlFor='user_email'>Password</label>
              <input type='password' name='password' onChange={(e) => this.updateValue(e)} />
            </div>

            <button className='dark' onClick={(e) => this.createNewUser(e)}>
              Create Account
            </button>

            <div className='content--step1-bottom content__bot-div'>
              <div>
                <h4>Already have a Brandfolder account?</h4>
                <a className='link' href={`/signin?return_to=${window.location.href}`}><h5>Log In</h5></a>
              </div>
              <div className='terms'>
                <h6>By clicking "Create Account" you agree to our </h6>
                <a className='link' href='https://brandfolder.com/agreement/#!texts/14negh88' target='_blank' rel='noopener noreferrer'>
                  <h6>Terms of Service</h6>
                </a>
                <h6> and </h6>
                <a className='link' href='https://brandfolder.com/agreement/#!asset/xpxac06k' target='_blank' rel='noopener noreferrer'>
                  <h6>Privacy Policy</h6>
                </a>
              </div>
            </div>
          </form>
        </div>
      )
    }
  }
}
